import React from 'react';
import './PreviewPanels.css';

/*
 * Original concept preview for EventShield (not a screenshot of a deployed app).
 * Inline SVG drawn at a 480x270 (16:9) design size so it scales cleanly inside
 * the shared featured-card media slot. Kept deliberately sparse with a large
 * type scale so the panels stay readable when the card narrows on mobile.
 * All sample content is fictional and generic: no real company names, customer
 * data or usage metrics. Decorative by design; the honest "Concept Preview"
 * label lives in the DOM next to it.
 */
function EventShieldPreview() {
  return (
    <svg
      className="preview-svg"
      viewBox="0 0 480 270"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="480" height="270" fill="#f7f1e7" />

      {/* app header strip */}
      <g>
        <rect width="480" height="34" fill="#eee5d4" />
        <rect x="14" y="11" width="12" height="12" rx="3.5" fill="#7d9a73" />
        <text className="pv-t pv-strong" x="32" y="22">
          EventShield
        </text>
        <rect x="352" y="9" width="112" height="17" rx="8" fill="#e0d5c1" />
        <text className="pv-t pv-label" x="362" y="21">
          FAILED EVENTS
        </text>
      </g>

      {/* left column: captured event queue */}
      <g>
        <text className="pv-t pv-label" x="14" y="48">
          EVENT QUEUE
        </text>

        {/* selected, failing event */}
        <rect x="12" y="54" width="170" height="44" rx="8" fill="#fbeae6" stroke="#d99383" strokeWidth="1.4" />
        <rect x="12" y="54" width="4" height="44" rx="2" fill="#c8695a" />
        <text className="pv-t pv-strong" x="24" y="75">
          /api/orders/sync
        </text>
        <text className="pv-t pv-alert" x="24" y="91">
          500 · 14:32
        </text>

        {/* other queued events */}
        <rect x="12" y="104" width="170" height="44" rx="8" fill="#fffdf8" stroke="#e6ddcb" strokeWidth="1.2" />
        <text className="pv-t" x="24" y="125">
          /webhooks/stock
        </text>
        <text className="pv-t pv-dim" x="24" y="141">
          502 · retry
        </text>

        <rect x="12" y="154" width="170" height="44" rx="8" fill="#fffdf8" stroke="#e6ddcb" strokeWidth="1.2" />
        <text className="pv-t" x="24" y="175">
          /api/users/invite
        </text>
        <text className="pv-t pv-dim" x="24" y="191">
          422 · queued
        </text>

        <rect x="12" y="204" width="170" height="44" rx="8" fill="#fffdf8" stroke="#e6ddcb" strokeWidth="1.2" />
        <text className="pv-t" x="24" y="225">
          /webhooks/billing
        </text>
        <text className="pv-t pv-dim" x="24" y="241">
          500 · queued
        </text>
      </g>

      {/* right column: inspect, diagnose, remediate */}
      <g>
        {/* selected event */}
        <rect x="192" y="46" width="276" height="38" rx="8" fill="#e7eef3" stroke="#a9c7d8" strokeWidth="1.2" />
        <text className="pv-t pv-strong" x="204" y="70">
          POST /api/orders/sync
        </text>
        <rect x="402" y="56" width="54" height="18" rx="9" fill="#f2c6bb" />
        <text className="pv-t pv-label" x="407" y="69">
          FAILED
        </text>

        {/* payload */}
        <rect x="192" y="90" width="276" height="58" rx="8" fill="#fffdf8" stroke="#e6ddcb" strokeWidth="1.2" />
        <text className="pv-t pv-label" x="204" y="107">
          PAYLOAD
        </text>
        <text className="pv-t pv-dim" x="204" y="126">
          order_id: null
        </text>
        <text className="pv-t pv-dim" x="204" y="142">
          event: order.sync
        </text>

        {/* error trace */}
        <rect x="192" y="154" width="276" height="44" rx="8" fill="#fffdf8" stroke="#e6ddcb" strokeWidth="1.2" />
        <text className="pv-t pv-label" x="204" y="171">
          ERROR TRACE
        </text>
        <text className="pv-t pv-alert" x="204" y="190">
          ValidationError at syncOrder:84
        </text>

        {/* diagnosis */}
        <rect x="192" y="204" width="276" height="30" rx="8" fill="#e7eef3" stroke="#a9c7d8" strokeWidth="1.2" />
        <text className="pv-t pv-label" x="204" y="223">
          DIAGNOSIS
        </text>
        <text className="pv-t" x="272" y="223">
          Missing field: order_id
        </text>

        {/* remediation */}
        <rect x="192" y="240" width="276" height="28" rx="8" fill="#eaf0e6" stroke="#a8be9a" strokeWidth="1.2" />
        <text className="pv-t pv-label" x="204" y="258">
          FIX
        </text>
        <text className="pv-t pv-good" x="234" y="258">
          + validate(order_id)
        </text>
      </g>
    </svg>
  );
}

export default EventShieldPreview;
